export const classString = (...args) => args.map((arg) => {
    if (typeof arg === 'string') {
        return arg;
    }

    if (typeof arg === 'object') {
        return Object.keys(arg).filter(argKey => !!arg[argKey]).join(' ');
    }

    return '';
}).filter(a => !!a).join(' ');
